"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TranslationKey = void 0;
/* istanbul ignore file @preserve */ /**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */ let TranslationKey = exports.TranslationKey = /*#__PURE__*/ function(TranslationKey) {
    TranslationKey["author"] = "author";
    TranslationKey["faq"] = "faq";
    TranslationKey["inspirationCorner"] = "inspirationCorner";
    TranslationKey["otherCategories"] = "otherCategories";
    TranslationKey["photo"] = "photo";
    TranslationKey["published"] = "published";
    TranslationKey["readLess"] = "readLess";
    TranslationKey["readMore"] = "readMore";
    TranslationKey["readNow"] = "readNow";
    TranslationKey["view"] = "view";
    return TranslationKey;
}({});
